import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import LinkButton from "./LinkButton";
import {authOpen} from '../actions/creators';
import {cinemaSelectorOpen,areaSelectorOpen} from '../actions/creators/ui';
import {getUserInfo,getSelectedCinema} from '../reducers';
import {onAvatarLoadError} from '../utils/misc';
import {breakpoints} from '../utils/styles';

const Avatar = styled.img`
  display: block;
  margin-left: 2em;
  vertical-align: middle;
  max-width: 1.75rem;
`;

const NoAvatarIcon = styled.i`
  font-size: 1.75rem;
`;

const CinemaName = styled.span`
  @media screen and (max-width: ${breakpoints.phone - 1}px) {
    display: none;
  }
`;

const MobileLabel = styled.span`
  display: none;
  font-size: 2.25vw;

  @media screen and (max-width: ${breakpoints.phone - 1}px) {
    display: inline;
  }
`;

const NavItem = styled.li`
  @media screen and (max-width: ${breakpoints.phone - 1}px) {
    font-size: 0.85rem;
  }

  @media screen and (max-width: ${breakpoints.tablet - 1}px) {
    margin-right: 0.75rem;
  }
`;

const CINEMA_PLACEHOLDER = 'Cambiar cine';

class UserCinemaNavLinks extends React.PureComponent {
  constructor(props) {
    super(props);

    this.renderUserIcon = this.renderUserIcon.bind(this);
  }

  render() {
    return (
        <React.Fragment>
          <NavItem>
            {/* {this.props.cinemaSelector !== false && (
                <LinkButton onClick={this.props.openCinemaSelector} icon='fa-angle-down'>
                  <CinemaName>{this.props.cinema ? this.props.cinema.name : CINEMA_PLACEHOLDER}</CinemaName>
                  <MobileLabel>{CINEMA_PLACEHOLDER}</MobileLabel>
                </LinkButton>
            )} */}
            {this.props.areaSelector === true && (
                <LinkButton onClick={this.props.openAreaSelector} icon='fa-angle-down'>
                  {this.props.area ? this.props.area.name : 'Selecciona una zona'}
                </LinkButton>
            )}
            {this.props.areaSelector && React.isValidElement(this.props.areaSelector) && this.props.areaSelector}
          </NavItem>
          {this.props.userIcon !== false && (
            <li className='d-none d-md-inline-block'>
              {this.renderUserIcon()}
            </li>
          )}
        </React.Fragment>
    );
  }

  renderUserIcon() {
    if (!this.props.userInfo) {
      return <LinkButton className="nav-link ml-5" onClick={this.props.authOpen}>
        <NoAvatarIcon className="fal fa-user-circle"></NoAvatarIcon>
      </LinkButton>;
    } else {
      return <Link to="/usuario/">
        <Avatar src={this.props.userInfo.avatar} className="rounded-circle" onError={onAvatarLoadError}/>
      </Link>;
    }
  }
}

const mapStateToProps = (state, props) => ({
  userInfo: getUserInfo(state),
  cinema: props.cinema || getSelectedCinema(state),
});

const mapDispatchToProps = dispatch => ({
  authOpen: () => dispatch(authOpen()),
  openCinemaSelector: () => dispatch(cinemaSelectorOpen()),
  openAreaSelector: () => dispatch(areaSelectorOpen()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserCinemaNavLinks);